





















import './KisweInfoSlate.scss'
import { defineComponent } from '@vue/composition-api'
import KisweIcon from '../KisweIcon'
import { KisweSpin } from '../../types'

export default defineComponent({
  name: 'KisweInfoSlate',
  components: {
    KisweIcon
  },
  props: {
    caption: {
      type: String,
      required: false,
      default: undefined
    },
    iconName: {
      type: String,
      required: false,
      default: undefined
    },
    iconSpin: {
      type: String as () => KisweSpin,
      required: false,
      default: KisweSpin.Off,
      validator: (value: KisweSpin) => Object.values(KisweSpin).includes(value)
    }
  },
  computed: {
    hasSlotIcon (): boolean {
      return !!this.$slots.icon
    },
    hasSlotCaption (): boolean {
      return !!this.$slots.caption
    }
  }
})
